import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    { attrs: { "data-doctors-register-app": "" } },
    [
      _c(_setup.DoctorsRegisterContent),
      _vm._v(" "),
      _setup.BaseDialog
        ? _c(_setup.BaseDialog, { tag: "component" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }